import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { Notification } from '@app/entities/models/notifications/notification.model';

export interface NotificationRepository {
  fetchNotifications(lang: string): Observable<Notification[]>;
  checkAsReadNotification(notification: Notification): Observable<void>;
  getSectionMaintenance(): void;
}

export const NOTIFICATION_REPOSITORY = new InjectionToken<NotificationRepository>('NOTIFICATION_REPOSITORY');
